import { useFieldValidationErrors } from 'components/common-form/hooks/useFieldValidationError';
import { ValidationFeedbackMessage } from 'components/shared/FormGroup/ErrorMessages';
import { FC } from 'react';

export interface FormGroupValidationFeedbackMessageProps<InputId = string> {
  inputId: InputId;
}
export const FormGroupValidationFeedbackMessage: FC<FormGroupValidationFeedbackMessageProps> = ({ inputId }) => {
  const validationErrors = useFieldValidationErrors(inputId, 'secondaryMarket.form.errors.');
  return (
    <div>
      {validationErrors.map(validationError => (
        <ValidationFeedbackMessage
          key={validationError.message}
          validationError={validationError}
          e2e={`${inputId}-error-msg`}
        />
      ))}
    </div>
  );
};
